function initDichVuContactScroll() {
	if (!document.body.classList.contains("single-dich-vu")) return;

	document.addEventListener("click", (event) => {
		const trigger = event.target.closest(".btn-primary");
		if (!trigger) return;

		const isSectionCta = trigger.closest(".top-banner, .niengrang-about");
		const href = trigger.getAttribute("href") || "";
		const isContactHash =
			trigger.hash === "#contact-form" ||
			href.split("#")[1] === "contact-form";

		if (!isSectionCta && !isContactHash) return;

		const target = document.getElementById("contact-form");
		if (!target) return;

		event.preventDefault();

		const header = document.querySelector("header");
		const offset = header ? header.offsetHeight : 0;
		const top =
			target.getBoundingClientRect().top + window.scrollY - offset;

		window.scrollTo({
			top: Math.max(0, top),
			behavior: "smooth",
		});
	});
}

export function initNiengRang() {
	initDichVuContactScroll();

	const accordions = document.querySelectorAll(
		"[data-js-target='niengrang-benefits'], [data-js-target='niengrang-ct-benefits'], [data-js-target='niengrang-ct-faq']"
	);

	accordions.forEach((accordion) => {
		const items = accordion.querySelectorAll("[data-js-item]");

		accordion.addEventListener("click", (event) => {
			const trigger = event.target.closest(
				"[data-js-action='toggle-accordion']"
			);
			if (!trigger) return;

			const item = trigger.closest("[data-js-item]");
			if (!item) return;

			const panel = item.querySelector("[data-js-panel]");
			if (!panel) return;

			const isActive = item.classList.contains("is-active");

			items.forEach((entry) => {
				entry.classList.remove("is-active");

				const entryButton = entry.querySelector(
					"[data-js-action='toggle-accordion']"
				);
				const entryPanel = entry.querySelector("[data-js-panel]");
				const entryIcon = entryButton?.querySelector("i");

				if (entryButton) {
					entryButton.setAttribute("aria-expanded", "false");
				}
				if (entryPanel) {
					entryPanel.hidden = true;
				}
				if (entryIcon) {
					entryIcon.classList.remove("fa-minus");
					entryIcon.classList.add("fa-plus");
				}
			});

			if (!isActive) {
				item.classList.add("is-active");
				trigger.setAttribute("aria-expanded", "true");
				panel.hidden = false;

				const icon = trigger.querySelector("i");
				if (icon) {
					icon.classList.remove("fa-plus");
					icon.classList.add("fa-minus");
				}
			}
		});
	});

	document.querySelectorAll("[data-js-target='niengrang-methods']").forEach((tabs) => {
		const tabButtons = tabs.querySelectorAll("[data-js-action='switch-tab']");
		const panels = tabs.querySelectorAll("[data-js-panel]");

		tabButtons.forEach((button) => {
			button.addEventListener("click", () => {
				if (button.classList.contains("is-active")) return;

				const target = button.getAttribute("data-js-tab");
				if (!target) return;

				tabButtons.forEach((entry) => {
					entry.classList.remove("is-active");
					entry.setAttribute("aria-selected", "false");
				});

				panels.forEach((panel) => {
					const isActive = panel.getAttribute("data-js-panel") === target;
					panel.classList.toggle("is-active", isActive);
					panel.hidden = !isActive;
				});

				button.classList.add("is-active");
				button.setAttribute("aria-selected", "true");
			});
		});
	});
}
